import defineComponent from 'flight';
import WithAjax from 'static/script/app/data/with-ajax';

function KlarnaPinService() {
    this._submit = function(evt, eventData) {
        let success = function(data) {
            this._handleResult(data);
        };

        this._post({
            url: '/my/klarna-pin',
            data: eventData,
            success: success.bind(this),
            error: 'data:klarna-pin:on-submit-error'
        });
    };

    this._handleResult = function(data) {
        let payload = data;
        this.trigger(document, 'data:klarna-pin:after-submit', payload);
    };

    this.after('initialize', function() {
        this.on('ui:klarna-pin:submit', this._submit);
    });
}

export default defineComponent.component(KlarnaPinService, WithAjax);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/klarna-pin-service.js